import Vue from 'vue';
import { extend, localize, ValidationProvider, ValidationObserver } from 'vee-validate';
import { email, required, integer, min_value, confirmed, min, max, regex, numeric } from 'vee-validate/dist/rules';
import { url } from './rules/url';

function loadLocale(code) {
  return import(`vee-validate/dist/locale/${code}.json`)
    .then(locale => {
      localize(code, locale);
    });
}

extend('email', email);
extend('required', required);
extend('integer', integer);
extend('min_value', min_value);
extend('confirmed', confirmed);
extend('min', min);
extend('max', max);
extend('regex', regex);
extend('numeric', numeric);
extend('url', url);
loadLocale('en');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

export {
  loadLocale,
};